'use strict';

module.exports = function(Chart) {

	Chart.Radar = function(context, config) {
		config.type = 'radar';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./~/ng2-charts/~/chart.js/src/charts/Chart.Radar.js
// module id = 517
// module chunks = 55